import { motion } from "framer-motion";

export default function AuthOrDivider() {
	return (
		<motion.div
			initial={{ opacity: 0, y: 4 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.2, ease: "easeOut" }}
			className="relative my-6"
			aria-hidden="true"
		>
			<div className="absolute inset-0 flex items-center">
				<div className="w-full border-t border-neutral-200" />
			</div>
			<div className="relative flex justify-center text-xs font-medium uppercase tracking-wide">
				<span className="bg-white px-3 text-neutral-500">OR</span>
			</div>
		</motion.div>
	);
}
